// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"98":"8ed0c0c7","517":"plr"}[chunkId] || chunkId) + "." + {"98":"c51943768dfeea1fd576","488":"1cf0b9df5076f46d8ebb","517":"898bb8f6e62398d210d0"}[chunkId] + ".js";
};